import H2 from '@base/H2/H2';
import H6 from '@base/H6/H6';
import { Spacings, mediaQuery } from '@styles/index';
import styled from '@emotion/styled';

const Wrapper = styled.section`
  padding: ${Spacings.SPACING_16B} ${Spacings.SPACING_4B};
  background: var(--color-base-1);
  ${mediaQuery.uptoTablet} {
    padding-top: ${Spacings.SPACING_12B};
    padding-bottom: ${Spacings.SPACING_12B};
  }
`;

const Content = styled.div`
  max-width: 1136px;
  margin: auto;
`;

const SubHeading = styled(H6)`
  color: var(--color-i-green);
  letter-spacing: 1px;
  text-align: center;
  text-transform: uppercase;
`;

const MainHeading = styled(H2)`
  color: var(--color-i-blue);
  margin-top: ${Spacings.SPACING_2B};
  margin-bottom: ${Spacings.SPACING_10B};
  text-align: center;
`;

const Items = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoTablet} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${mediaQuery.uptoMobile} {
    grid-template-columns: 1fr;
  }
`;

const Item = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacings.SPACING_4B};
  padding: ${Spacings.SPACING_5B} ${Spacings.SPACING_6B};
  border-radius: 8px;
  background: rgba(150, 194, 255, 0.16);
  text-decoration: none;
`;

const GoalName = styled(H6)`
  min-width: 0;
`;

const Download = styled(H6)`
  flex-shrink: 0;
  white-space: nowrap;
  color: var(--color-i-green);
`;

const ClassAndSyllabuses = ({ data }) => {
  if (!data?.syllabusItems?.length) return null;

  return (
    <Wrapper>
      <Content>
        <SubHeading>{data.subHeading}</SubHeading>
        <MainHeading>{data.mainHeading}</MainHeading>
        <Items>
          {data.syllabusItems.map((item) => (
            <Item
              key={item.id}
              href={item.syllabusPdf?.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <GoalName>{item.goalName}</GoalName>
              <Download>Download</Download>
            </Item>
          ))}
        </Items>
      </Content>
    </Wrapper>
  );
};

export default ClassAndSyllabuses;
